import React, { useEffect, useState } from 'react';
import { trackFbEvent } from '../utils/fbPixel';
type Plan = 'megapack' | 'megapack-pro';
export function Pricing() {
  const [selected, setSelected] = useState<Plan>('megapack-pro');
  useEffect(() => {
    const section = document.getElementById('pricing');
    if (!section) return;
    const observer = new IntersectionObserver(entries => {
      if (entries[0].isIntersecting) {
        trackFbEvent('ViewContent', {
          content_name: 'Pricing Section',
          content_category: 'Psicología Carrera Resuelta'
        });
        observer.disconnect();
      }
    }, {
      threshold: 0.3
    });
    observer.observe(section);
    return () => observer.disconnect();
  }, []);
  const cartUrls: Record<Plan, string> = {
    megapack: 'https://www.bibliotecaprofesional.com/cart/48278094446762:1',
    'megapack-pro': 'https://www.bibliotecaprofesional.com/cart/48278094839978:1'
  };
  const plans = {
    megapack: {
      emoji: '🧠',
      name: 'MEGAPACK PSICOLOGÍA CARRERA RESUELTA',
      desc: '6 tomos + 6 bonos · Toda la carrera organizada',
      priceOld: '$58.990',
      priceNew: '$22.990',
      priceColor: '#1E1208',
      cta: '→ SÍ, QUIERO EL MEGAPACK',
      sub: '6 tomos · 6 bonos · Acceso inmediato'
    },
    'megapack-pro': {
      emoji: '🏆',
      name: 'MEGAPACK + MÁSTER PSICOLOGÍA',
      desc: 'Todo el Megapack + el sistema completo para recibirte y arrancar tu práctica profesional.',
      priceOld: '$102.990',
      priceNew: '$29.990',
      priceColor: '#C8922A',
      cta: '→ SÍ, QUIERO EL MEGAPACK + MÁSTER PSICOLOGÍA',
      sub: '6 tomos · 6 bonos · Máster Psicología · Acceso inmediato'
    }
  };
  const active = plans[selected];
  return <section id="pricing" className="relative w-full px-4 sm:px-6 lg:px-8 py-8" style={{
    background: 'linear-gradient(180deg, #FEFAF4 0%, #FDF4E7 50%, #FDF4E7 100%)'
  }} data-id="element-222">
      <div className="mx-auto max-w-3xl" data-id="element-223">
        {/* Heading */}
        <div className="text-center mb-6" data-id="element-224">
          <div className="inline-flex items-center gap-2 text-[11px] font-bold tracking-wide rounded-full px-4 py-1.5 mb-3" style={{
          color: '#C8922A',
          border: '1px solid rgba(200,146,42,0.40)',
          backgroundColor: 'rgba(200,146,42,0.06)'
        }} data-id="element-225">
            🔥 Precio de lanzamiento — Sube sin previo aviso
          </div>
          <h2 className="text-2xl sm:text-3xl font-black m-0 mb-1" style={{
          color: '#1E1208'
        }} data-id="element-226">
            Elegí tu{' '}
            <span style={{
            color: '#C8922A'
          }} data-id="element-227">
              Megapack:
            </span>
          </h2>
          <p className="text-xs m-0" style={{
          color: '#9A7B5A'
        }} data-id="element-228">
            Las dos opciones incluyen los 6 bonos completos
          </p>
        </div>

        {/* Plan Selector */}
        <div className="flex flex-col gap-2.5 mb-5" data-id="element-229">
          {(Object.keys(plans) as Plan[]).map(plan => {
          const p = plans[plan];
          const isSelected = selected === plan;
          return <button key={plan} onClick={() => setSelected(plan)} className="w-full text-left rounded-xl p-3.5 transition-all cursor-pointer" style={{
            border: isSelected ? '2px solid #C8922A' : '1px solid rgba(200,146,42,0.22)',
            backgroundColor: isSelected ? 'rgba(200,146,42,0.06)' : 'rgba(255,255,255,0.92)',
            boxShadow: isSelected ? 'rgba(200,146,42,0.18) 0px 0px 30px 0px' : undefined
          }} data-id="element-230">
                <div className="flex items-center gap-3" data-id="element-231">
                  {/* Radio */}
                  <div className="flex h-5 w-5 shrink-0 items-center justify-center rounded-full border-2" style={{
                borderColor: isSelected ? '#C8922A' : 'rgba(200,146,42,0.30)'
              }} data-id="element-232">
                    {isSelected && <div className="h-2.5 w-2.5 rounded-full" style={{
                  backgroundColor: '#C8922A'
                }} data-id="element-233" />}
                  </div>

                  {/* Info */}
                  <div className="flex-1 min-w-0" data-id="element-234">
                    <div className="flex flex-wrap items-center gap-2 mb-0.5" data-id="element-235">
                      <span data-id="element-236">{p.emoji}</span>
                      <span className="text-sm font-black" style={{
                    color: '#1E1208'
                  }} data-id="element-237">
                        {p.name}
                      </span>
                      {plan === 'megapack-pro' && <span className="text-[10px] font-black text-white rounded-full px-2 py-0.5" style={{
                    background: 'linear-gradient(135deg, #B8860B 0%, #C8922A 100%)'
                  }} data-id="element-238">
                          ⭐ MÁS ELEGIDO
                        </span>}
                    </div>
                    <p className="text-xs m-0" style={{
                  color: '#9A7B5A'
                }} data-id="element-239">
                      {p.desc}
                    </p>
                  </div>

                  {/* Price */}
                  <div className="shrink-0 text-right" data-id="element-240">
                    <div className="text-xs line-through" style={{
                  color: '#9A7B5A'
                }} data-id="element-241">
                      {p.priceOld}
                    </div>
                    <div className="text-2xl font-black" style={{
                  color: p.priceColor
                }} data-id="element-242">
                      {p.priceNew}
                    </div>
                  </div>
                </div>
              </button>;
        })}
        </div>

        {/* CTA Block */}
        <div className="rounded-2xl p-4 shadow-lg" style={{
        background: 'linear-gradient(135deg, #B8860B 0%, #C8922A 50%, #7A9E7E 100%)'
      }} data-id="element-243">
          <div className="flex flex-wrap justify-center gap-x-4 gap-y-1 mb-3" data-id="element-244">
            {active.sub.split(' · ').map(item => <span key={item} className="text-[11px] font-bold text-white/90 flex items-center gap-1" data-id="element-245">
                <span className="text-white/60" data-id="element-246">✓</span> {item}
              </span>)}
          </div>

          <a href={cartUrls[selected]} onClick={() => trackFbEvent('InitiateCheckout', {
          content_name: selected === 'megapack-pro' ? 'Megapack + Máster Psicología' : 'Megapack Psicología Carrera Resuelta',
          content_category: 'Psicología Carrera Resuelta',
          value: selected === 'megapack-pro' ? 29990 : 22990,
          currency: 'ARS'
        })} className="block w-full text-center text-sm sm:text-base font-black rounded-xl py-3.5 no-underline transition-colors hover:opacity-90" style={{
          backgroundColor: '#FEFAF4',
          color: '#B8860B'
        }} data-id="element-247">
            {active.cta}
          </a>

          <p className="text-center text-[11px] text-white/70 mt-2.5 mb-0" data-id="element-248">
            +1.800 estudiantes ya tienen toda la carrera organizada en un solo
            lugar
          </p>
        </div>

        {/* Trust Badges */}
        <div className="mt-3 flex flex-wrap items-center justify-center gap-3 text-xs rounded-xl px-4 py-2.5 shadow-sm" style={{
        backgroundColor: 'rgba(255,255,255,0.92)',
        border: '1px solid rgba(200,146,42,0.18)',
        color: '#6B4C35'
      }} data-id="element-249">
          <span data-id="element-250">🔒 Pago seguro</span>
          <span data-id="element-251">⚡ Acceso en 5 min</span>
          <span data-id="element-252">🛡️ Garantía 7 días</span>
          <span data-id="element-253">💳 Mercado Pago</span>
        </div>
      </div>

      {/* Degradé inferior → conecta con ProBusiness */}
      <div className="absolute bottom-0 left-0 w-full h-16 pointer-events-none" style={{
      background: 'linear-gradient(180deg, transparent 0%, #FDF4E7 100%)'
    }} data-id="element-254" />
    </section>;
}